var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoAtencao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.682,
    height: 17.862,
    viewBox: "0 0 18.682 17.862",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11,10h2v5H11Zm0,6h2v2H11Z",
    transform: "translate(-2.659 -3.138)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.768,4.2a2,2,0,0,0-3.536,0L2.894,18.064A2,2,0,0,0,4.661,21H19.339a2,2,0,0,0,1.768-2.936ZM4.661,19,12,5.137,19.344,19Z",
    transform: "translate(-2.659 -3.138)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAtencao);
export default __webpack_public_path__ + "static/media/ico-atencao.15393bfa802ed8b3e3c2e89bac14234f.svg";
export { ForwardRef as ReactComponent };